module.exports = __webpack_public_path__ + "img/payment_mb_02.86a7ff29.png";